var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#help_svg__help_svg__clip0_561_1694)",
    stroke: "#6E7D8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15zm0-3.333v.008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.25a1.25 1.25 0 01.833-1.25 2.167 2.167 0 10-2.5-3.333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "help_svg__help_svg__clip0_561_1694"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgHelp;